import axios from 'axios';

const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production'
    ? '/api'
    : 'http://localhost:5000/api');
const base = (kind, id) => `${API_BASE_URL}/video-thumbnails/${kind}/${id}`;

const listeners = new Map();
const VideoThumbnailService = {
  subscribe(kind, id, listener) {
    const key = `${kind}/${id}`;
    if (!listeners.has(key)) listeners.set(key, new Set());
    listeners.get(key).add(listener);
    return () => {
      const subscribers = listeners.get(key);
      subscribers?.delete(listener);
      if (!subscribers?.size) listeners.delete(key);
    };
  },
  notifyChanged(kind, id) {
    listeners.get(`${kind}/${id}`)?.forEach((listener) => listener());
  },
  async get(kind, id) {
    return (await axios.get(base(kind, id))).data;
  },
  async image(kind, id) {
    return (
      await axios.get(`${base(kind, id)}/image`, { responseType: 'blob' })
    ).data;
  },
  async save(kind, id, file) {
    const result = (
      await axios.put(base(kind, id), file, {
        params: { fileName: file.name },
        headers: { 'Content-Type': file.type },
      })
    ).data;
    this.notifyChanged(kind, id);
    return result;
  },
  // The server downloads and checks the image, returning it to use like a
  // chosen file.
  async download(url) {
    const { fileName, contentType, data } = (
      await axios.post(`${API_BASE_URL}/video-thumbnails/download`, { url })
    ).data;
    const bytes = Uint8Array.from(atob(data), (char) => char.charCodeAt(0));
    return new File([bytes], fileName, { type: contentType });
  },
  async remove(kind, id) {
    const result = (await axios.delete(base(kind, id))).data;
    this.notifyChanged(kind, id);
    return result;
  },
};

export default VideoThumbnailService;
